import Swiper from 'swiper';

export default function () {
  if (!$('.swiper-wrapper')) return;

  $('[data-type="publications-slider"]').each((i, el) => {
    const $this = $(el);
    const $btnPrev = $this.find('[data-type="button-prev"]');
    const $btnNext = $this.find('[data-type="button-next"]');

    const swiperConfig = {
      loop: false,
      effect: 'slide',
      speed: 700,
      slidesOffsetBefore: 250,
      spaceBetween: 150,
      parallax: true,
      autoHeight: false,
      slideToClickedSlide: true,
      slidesPerView: 'auto',
      centeredSlides: false,
      navigation: {
        nextEl: $btnNext,
        prevEl: $btnPrev,
      },
      breakpoints: {
        1024: {
          spaceBetween: 50,
          slidesOffsetBefore: 50,
        },
        640: {
          centeredSlides: true,
          slidesOffsetBefore: 0,
        },
      },
    };

    const slider = el.querySelector('[data-type="publications-slider-slides"]');

    if (!slider) return;

    new Swiper(slider, swiperConfig);
  });
  $('[data-type="media-slider"]').each((i, el) => {
    const $this = $(el);
    const typeStyle = $this.data('style');
    let $pagination = $this.find('[data-type="pagination"]');
    let $btnPrev = $this.find('[data-type="button-prev"]');
    let $btnNext = $this.find('[data-type="button-next"]');

    if (typeStyle === 'type2') {
      $pagination = null;
      $btnPrev = null;
      $btnNext = null;
    }

    const swiperConfig = {
      loop: false,
      effect: 'slide',
      speed: 700,
      spaceBetween: 30,
      autoHeight: false,
      slideToClickedSlide: true,
      slidesPerView: 'auto',
      centeredSlides: false,
      pagination: {
        el: $pagination,
        type: 'progressbar',
      },
      navigation: {
        nextEl: $btnNext,
        prevEl: $btnPrev,
      },
    };

    const slider = el.querySelector('[data-type="media-slider-slides"]');

    if (!slider) return;

    new Swiper(slider, swiperConfig);
  });
}



// WEBPACK FOOTER //
// ./scripts/blocks/sliders.js